import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import cn from 'classnames';
import 'react-simple-keyboard/build/css/index.css';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import { getFormatedPhoneNumber, safeJsonParse } from '@utility/helperFunction';
import PhoneNumberComponent from '@components/common/PhoneNumberComponent/indexRevamp';
import {
  getObjectValue,
  deconstructStringUrl,
  replaceAll,
  urlSearchParams
} from '@utility/utills';
import Keyboard from '@components/KeyboardV2';
import { flowType } from '@utility/userInfo';
import style from './loyaltyCopy.module.scss';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import LoyaltyLightImg from '@assets/images/loyaltyLight.png';
import LoyaltyImg from '@assets/images/loyalty.png';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import PropTypes from "prop-types";
import { connect } from 'react-redux';

const LoyaltyKeyboard = ({
  name,
  handleLoyaltySubmit,
  placeHolder,
  countryCode,
  handleCountryCodeChange,
  loyaltyMethod,
  handleBackButton,
  ShowLandscapeMode,
  joinMethod,
  serverAppTheme,
  handleLoyaltyInfo,
  isLoyaltyBalance,
  themeProperties,
  lookupMethods,
  handleCancel,
  setErrorPopUp,
  isLandScape,
  isSpeedOrder,
  isCallCenter,
  isOffPremiseOrder,
  orderingPortraitOrientation
}) => {
  const isKiosk = flowType() === 'kiosk';
  const [swipedDown, setSwipedDown] = useState(true);
  const ref = useRef(null);
  const [inputName, setInputName] = useState(`${name}`);
  const [inputs, setInputs] = useState({});
  const [disclamer, setDisclamer] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const timeoutId = useRef(null);
  const [keyboardType, setKeyboardType] = useState(
    name === 'Email' ? 'textWithNumericEmail' : 'numericWithBin'
  );
  const [typed, setTyped] = useState({});
  const typedRef = useRef(typed);
  const inputsRef = useRef(inputs);
  typedRef.current = typed;
  inputsRef.current = inputs;
  const isServerApp = flowType() === 'serverApp';
  const screenType = ["31"].includes((urlSearchParams("screenType")));
  const themeNumber = safeJsonParse(window.sessionStorage.getItem('auth'))?.serverAppTheme ?? null;
  const authInfo = useMemo(
    () =>
      getObjectValue(
        () => JSON.parse(window.sessionStorage.getItem('auth')),
        null
      ),
    []
  );
  const storeInfo = authInfo ?? {};
  const getTheme = authInfo?.serverAppTheme;
  useEffect(() => {
    const disclamers = storeInfo?.loyaltyInfo?.loyaltyDisclaimer || '';
    if (disclamers?.length > 0) {
      const [, concatChar] = deconstructStringUrl(disclamers);
      setDisclamer(concatChar.split('¿'));
    }
  }, []);
  const handleLink = text => {
    timeoutId.current = setTimeout(() => {
      clearTimeout(timeoutId.current);
    }, 30 * 1000);
  };

  const handleBlur = () => {
    setSwipedDown(true);
    const element = document.querySelector(`#${name}`);
    element.blur();
  };

  const getInputValue = inputNameDat => {
    return inputs[inputNameDat] || '';
  };

  const onChangeInput = event => {
    const inputVal = event.target.value;
    setInputName(`${name}`);
    setSwipedDown(true);
    if (ref.current) {
      ref.current.setInput(inputs[inputName], inputVal);
    }
  };

  const closeKeyboard = useCallback(() => {
    setSwipedDown(false);
  }, []);

  const onClickBtn = useCallback(
    e => {
      const typed = typedRef.current;
      const inputs = inputsRef.current;

      // Control keys
      const controlKeys = new Set(['{bksp}', '{space}', '{enter}', '{tab}']);

      if (!controlKeys.has(e)) {
        const currentVal = typed[inputName] || '';

        const limit = inputName === 'PhoneNumber' ? returnMaxLength() : 0;

        if (Number(limit) > 0 && currentVal.length >= Number(limit)) {
          return;
        }
      }

      const value =
        e === '{bksp}'
          ? { ...typed, [inputName]: typed[inputName]?.slice(0, -1) }
          : {
              ...typed,
              [inputName]: typed[inputName]
                ? typed[inputName].concat(e)
                : ''.concat(e),
            };

      setTyped(value);

      setInputs({
        ...inputs,
        [inputName]:
          inputName === 'PhoneNumber' && Number(countryCode) === 1
            ? getFormatedPhoneNumber(value[inputName])
            : value[inputName],
      });
    },
    [inputName]
  );

  const handleSetInputEmpty = useCallback(() => {
    setInputs({ ...inputsRef.current, [inputName]: '' });
    setTyped({ ...typedRef.current, [inputName]: '' });
  }, [inputName]);

  const handleClear = () => {
    setInputs({
      ...inputs,
      [inputName]: '',
    });
    setTyped({
      ...typed,
      [inputName]: '',
    });
  };

  const handleSubmit = fieldName => {
    const inputValue = replaceAll(inputs[inputName], '-');
    let inputError = '';
    if (!inputValue) {
      setErrorPopUp({
        res:
          inputName === 'PhoneNumber'
            ? CUSTOM_MESSAGES().OLS_NUMBER_FIELD_REQUIRED
            : CUSTOM_MESSAGES().OLS_EMAIL_FIELD_REQUIRED,
        noErrorTxt: true,
      });
      return;
    } else if (
      countryCode === '1' &&
      inputValue?.length < 10 &&
      inputName === 'PhoneNumber'
    ) {
      setErrorPopUp({
        res: CUSTOM_MESSAGES().OLS_NUMBER_DEGIT_ERROR,
        noErrorTxt: true,
      });
      return;
    } else if (inputName === 'Email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(inputValue)) {
        setErrorPopUp({
          res: CUSTOM_MESSAGES().OLS_EMAIL_INVALID,
          noErrorTxt: true,
        });
        return;
      }
    } else if (
      !termsAccepted &&
      storeInfo.loyaltyInfo.loyaltyDisclaimer &&
      !isLoyaltyBalance
    ) {
      setErrorPopUp({
        res: CUSTOM_MESSAGES().OLS_PLEASE_AGREE_TERMS,
        noErrorTxt: true,
      });
      return;
    }
    if (inputError?.length === 0) {
      !isLoyaltyBalance &&
        handleLoyaltyInfo(
          inputName === 'PhoneNumber'
            ? { phoneNumber: inputValue, email: null, type: inputName }
            : { phoneNumber: null, email: inputValue, type: inputName }
        );
      handleLoyaltySubmit(inputValue, fieldName, termsAccepted);
    }
  };

  useEffect(() => {
    if (ref.current) {
      setInputs({
        ...inputs,
        [inputName]: inputs[inputName],
      });
      ref.current.input = {
        ...inputs,
        [inputName]: replaceAll(inputs[inputName], '-'),
      };
    }
  }, [swipedDown]);

  const returnMaxLength = () => {
    if (Number(countryCode) === 1) {
      return 10;
    }
    return 15;
  };

  const handleDomainSelect = domain => {
    const currentEmail = getInputValue(name);
    const prefix = currentEmail.split('@')[0];
    const updatedEmail = `${prefix}${domain}`;

    setTyped({
      ...typed,
      [name]: updatedEmail,
    });

    setInputs({
      ...inputs,
      [name]: updatedEmail,
    });

    if (ref.current) {
      ref.current.setInput(inputs[name], updatedEmail);
    }
  };
  const showCheckSeat = () => {
    if (!["1", "3"].includes(urlSearchParams('ticketSplitTypeId'))) {
     return !["29", "30"].includes((urlSearchParams("screenType"))) && !isSpeedOrder && !isCallCenter && !isOffPremiseOrder
    } else {
      return false;
    }
  };
  const loyaltyBalance = window.location.pathname.includes("/loyalty-balance");

  return (
    <div className={cn('h-100 w-100')}>
      {!isLandScape && !loyaltyBalance &&
      <div
        className={cn('w-100 pt-2', name !== 'Email' && 'pb-1 h-20')}
        style={{
          height: name === 'Email' && '138px',
        }}
      >
        {(loyaltyMethod === 'signIn' ? (
          themeProperties?.loyaltySignInImageUrl?.length > 0
        ) : (
          themeProperties?.loyaltySignUpImageUrl?.length > 0
        )) ? (
          <img
            src={
              loyaltyMethod === 'signIn'
                ? themeProperties?.loyaltySignInImageUrl
                : themeProperties?.loyaltySignUpImageUrl
            }
            alt=""
            className={cn('w-100 h-100')}
            style={{ objectFit: 'cover' }}
          />
        ) : getTheme === '2' ? (
          <img
            src={LoyaltyLightImg}
            style={{ width: '100%', objectFit: 'cover' }}
            className="h-100"
            alt="loyaltyLightImg"
          />
        ) : (
          <img
            src={LoyaltyImg}
            style={{ width: '100%', objectFit: 'cover' }}
            className="h-100"
            alt="loyaltyImg"
          />
        )}
      </div>
}
      {!isLandScape && !loyaltyBalance &&
        <div
          className="text-center py-1 fw-600 fs_28"
          style={{ fontFamily: 'Poppins', color: serverAppTheme?.primary_text }}
        >
          {loyaltyMethod === 'signIn' ? LABEL().LS_SIGN_IN : LABEL().LS_SIGN_UP}
        </div>
      }
      <div
        className={cn(
          style.overlay,
          isLandScape ? 'col-12 px-3 mt-2 d-flex justify-content-center' : 'col-12 px-0 position-relative',
        )}
        style={{top: (loyaltyBalance && orderingPortraitOrientation) ? '20%' : '', height: orderingPortraitOrientation ? '64px' : '44px' }}
      >
        {name === 'PhoneNumber' && (
          <PhoneNumberComponent
            countryCode={countryCode}
            styles={{
              top: 0,
              left: isLandScape ? '17%' : 0,
              padding: 'p-2',
              width: 'w-30 !important',
            }}
            isCustomWidth="w-35 fs-20"
            handleCountryCodeChange={e => {
              handleCountryCodeChange(e);
              handleClear();
            }}
            maxMenuHeight={200}
            screenType={'loyalty'}
            serverAppTheme={serverAppTheme}
            isLandScape={isLandScape}
          />
        )}
        <input
          id={name}
          type="emailText"
          name={name}
          className={cn(
            'form-control h-100',isLandScape ? 'col-8' : 'col-12',
            name === 'PhoneNumber' ? 'pt-2' : 'text-left',
            style.inputBg
          )}
          style={{
            fontSize: isServerApp ? '24px' : '20px',
            paddingLeft: name === 'PhoneNumber' && '10.2rem',
            background: serverAppTheme?.inputBg,
            borderBottom: serverAppTheme?.inputBorder_Bottom,
            color: serverAppTheme?.primary_text,
            '--placeholder-color': serverAppTheme?.input_placeholder,
          }}
          placeholder={placeHolder}
          value={getInputValue(`${name}`)}
          onFocus={e => {
            handleBlur();
            onChangeInput(e);
            setKeyboardType(
              name === 'PhoneNumber' || name === 'AccountNumber'
                ? 'numericWithBin'
                : 'textWithNumericEmail'
            );
          }}
        />
        {![0, ''].includes(inputs[inputName]) && inputs[inputName] && (
          <TouchableDiv
            role="presentation"
            className="position-absolute h-100"
            style={{ top: isLandScape ? '15%' : '23%', right: isLandScape ? '19%' : '1%' }}
            onClick={() => {
              handleClear();
            }}
          >
            <Cross fill={serverAppTheme?.iconcolor} />
          </TouchableDiv>
        )}
      </div>
      {/* <div
        className={cn(
          'fs-14 text-primary text-right h-3',
          name !== 'Email' && 'pt-1'
        )}
      >
        {error.length > 0 && error}
      </div> */}
      <div className={cn(name !== 'Email' && isLandScape ? (showCheckSeat() ? 'h-69' : 'h-72') : 'h-40' && name === 'Email' && screenType && isLandScape ? (showCheckSeat() ? 'h-55' : 'h-60') : 'h-40')}>
        {swipedDown && (
          <div className="pt-2" style={{top: (loyaltyBalance && orderingPortraitOrientation) ? '50%' : '', position: (loyaltyBalance && orderingPortraitOrientation) ? 'relative' : '' }}>
            <Keyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={onClickBtn}
              type={keyboardType}
              closeKeyboard={closeKeyboard}
              btnSize={
                isKiosk || keyboardType === 'emailText' ? 'btn'  : `btn35 ${isLandScape ? (showCheckSeat() ? 'py-1' : 'py-2') : 'py-2'}`
              }
              isDot
              isDone
              customClass={cn(
                `fs-30  border-0`,
                keyboardType === 'textWithoutNumeric' ? 'pl-1 pt-2' : 'pl-1'
              )}
              maxLength={inputName === 'PhoneNumber' && returnMaxLength()}
              spacebtn={style.spacebtn}
              setinputEmpty={handleSetInputEmpty}
              screenType={'loyalty'}
            />
          </div>
        )}
      </div>

      {/* Email Entry with Common Domain Pills */}
      {name === 'Email' && storeInfo?.emailDomainNames?.length > 0 && (
        <div
          className={cn(
            'd-flex flex-wrap o-group-menu w-100 align-items-center pb-2', isLandScape ? 'pt-2 pl-2' : 'pt-3'
          )}
        >
          {storeInfo?.emailDomainNames.map(domain => {
            return (
              <button
                key={domain}
                className={cn(
                  style.oUnselectedGroupBg,
                  'd-inline-flex text-nowrap px-3 fs_16 fw-500 rounded-pill py-1 mr-2 mb-2'
                )}
                type="button"
                onClick={() => handleDomainSelect(domain)}
                style={{
                  color: serverAppTheme?.primary_text,
                  border: `1px solid ${serverAppTheme?.modifiers_border}`,
                  background: 'none',
                }}
              >
                {domain}
              </button>
            );
          })}
        </div>
      )}

      {storeInfo?.loyaltyInfo?.loyaltyDisclaimer && !isLoyaltyBalance && (
        <TouchableDiv
          className={cn(
            'row mx-0 text-white',
            name === 'Email' ? 'pt-1' : 'h-10', isLandScape ? 'pt-0' : 'pt-4',
            isLandScape ? 'justify-content-center' : 'px-0'
          )}
        >
           <div className="col-12 d-flex justify-content-center align-items-center" style={{bottom: isLandScape ? '55px' : '90px', position: 'absolute'}}>
          <input
            className={style.checkbox}
            type="checkbox"
            name="disclaimer"
            style={{
              height: '22px',
              width: '22px',
              marginBottom: '1.5%',
              zIndex: '999',
              border: !termsAccepted && serverAppTheme?.checkbox_border,
              '--checkbox-checked-color': '#fff',
            }}
            onChange={e => {
              setTermsAccepted(e.target.checked);
            }}
          />
          <div
            className={cn(
              'px-2 fs_12 fw-400 text-left',
              isLandScape ? 'mb-2' : 'mb-0'
            )}
            style={{ color: serverAppTheme?.secondary_text }}
          >
            {disclamer?.length > 0 &&
              disclamer?.map(text => {
                return text.startsWith('#?') ? (
                  <>
                    {/* &nbsp; */}
                    <span
                      role="presentation"
                      onClick={() =>
                        text.startsWith('#?') &&
                        handleLink(text.replace('#?', ''))
                      }
                      className=" text white"
                    >
                      {text.replace('#?', '')}
                    </span>
                    {/* &nbsp; */}
                  </>
                ) : (
                  <>{text}</>
                );
              })}
          </div>
          </div>
        </TouchableDiv>
      )}
      <div
        className={cn('h-10 col-12 d-flex position-absolute', isLandScape ? 'px-3 justify-content-center' : 'px-0')}
        // style={{ bottom: isLandScape ? "45px" : screenType ? '0px' : '35px' }}
        style={{
          bottom: screenType ? "0px" : isLandScape ? "45px" : "35px", zIndex: 9999, background: themeNumber === '2' ? '#f5f7fb' : '#000',
        }}
      >
        <div className={cn('pl-0 pr-1 h-100 d-flex align-items-end', isLandScape ? 'col-5': 'col-6')}>
          <TouchableButton
            type="button"
            className={cn(
              'col-12 px-0 d-flex justify-content-center align-items-center od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color',
              style.loyalty_btn
            )}
            style={{ height: !isLandScape ? '64px' : '44px', backgroundColor: serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.primary_text, border: "1px solid #2541A4"}}
            onClick={e => {
              e.preventDefault();
              isLoyaltyBalance && lookupMethods
                ? handleCancel()
                : handleBackButton().url();
            }}
            rippleEffect={true}
          >
            <span className="fw-600 fs_28">{screenType ? LABEL().LS_CANCEL : LABEL().LB_CANCEL}</span>
          </TouchableButton>
        </div>
        <div className={cn('pl-1 pr-0 h-100 d-flex align-items-end', isLandScape ? 'col-5': 'col-6')}>
          <TouchableButton
            type="button"
            className={cn(
              'col-12 px-0 btn-ripple d-flex justify-content-center align-items-center od-primary-btn-bg-color od-primary-btn-font-color',
              // {
              //   'od-disable-btn-bg-color od-disable-btn-font-color': !inputs[inputName],
              //   'od-primary-btn-bg-color': inputs[inputName],
              // },
              style.loyalty_btn
            )}
            style={{ height: !isLandScape ? '64px' : '44px' }}
            // disabled={!inputs[inputName]}
            onClick={e => {
              e.preventDefault();
              handleSubmit(inputName);
            }}
            rippleEffect={true}
          >
            <span className="fw-600 fs_28">{screenType ? LABEL().LS_CONTINUE : LABEL().LB_CONTINUE}</span>
          </TouchableButton>
        </div>
      </div>
    </div>
  );
};

LoyaltyKeyboard.propTypes = {
  name: PropTypes.string,
  handleLoyaltySubmit: PropTypes.func,
  placeHolder: PropTypes.string,
  countryCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleCountryCodeChange: PropTypes.func,
  loyaltyMethod: PropTypes.string,
  handleBackButton: PropTypes.func,
  ShowLandscapeMode: PropTypes.bool,
  joinMethod: PropTypes.string,
  serverAppTheme: PropTypes.object,
  handleLoyaltyInfo: PropTypes.func,
  isLoyaltyBalance: PropTypes.bool,
  themeProperties: PropTypes.object,
  lookupMethods: PropTypes.array,
  handleCancel: PropTypes.func,
  setErrorPopUp: PropTypes.func,
  isLandScape: PropTypes.bool,
  isSpeedOrder: PropTypes.bool,
  isCallCenter: PropTypes.bool,
  isOffPremiseOrder: PropTypes.bool,
};

LoyaltyKeyboard.defaultProps = {
  name: "",
  handleLoyaltySubmit: () => {},
  placeHolder: "",
  countryCode: "",
  handleCountryCodeChange: () => {},
  loyaltyMethod: "",
  handleBackButton: () => ({ url: () => {} }),
  ShowLandscapeMode: false,
  joinMethod: "",
  serverAppTheme: {},
  handleLoyaltyInfo: () => {},
  isLoyaltyBalance: false,
  themeProperties: {},
  lookupMethods: [],
  handleCancel: () => {},
  setErrorPopUp: () => {},
  isLandScape: false,
  isSpeedOrder: false,
  isCallCenter: false,
  isOffPremiseOrder: false,
};
const mapStateToProps = state => ({
  orderingPortraitOrientation: state.orders.orderingPortraitOrientation
});

export default connect(mapStateToProps)(LoyaltyKeyboard);
